import CurrentDecorationItem from "./CurrentDecorationItem";

export default CurrentDecorationItem;
export { CurrentDecorationItem };
